import { render, staticRenderFns } from "./MWrapperFolder.vue?vue&type=template&id=15bf3982&scoped=true"
import script from "./MWrapperFolder.vue?vue&type=script&lang=js"
export * from "./MWrapperFolder.vue?vue&type=script&lang=js"
import style0 from "./MWrapperFolder.vue?vue&type=style&index=0&id=15bf3982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf3982",
  null
  
)

export default component.exports